import { TimeZoneService } from './../../../modules/shared/services/timezone.service';
import { Component, EventEmitter, Input, OnInit, OnDestroy, Output, SimpleChanges, OnChanges } from '@angular/core';
import { AppMainComponent } from '../../../app.main.component';
import { AppMainService } from '../../../app-main.service';
import {  LazyLoadEvent, MessageService } from 'primeng/api';
import { TasksService } from '../../tasks';
import { Subject, Subscription, forkJoin } from "rxjs";
import { takeUntil } from 'rxjs/operators';
import { TaskCategoryService } from 'src/app/shared/api/taskCategory.service';
import { removeHTMLTags } from 'src/app/modules/shared/helpers/remove-html-tags.helper';
import { TaskType } from "src/app/modules/shared/enums/task.enum"
import { ContextMenuItem } from 'src/app/accounts-v2/models/contextMenuItem.model';
import { FilterInColumn, GetTaskListingGroupByRequest, GetTaskListingModel } from '../models/getTaskListing.model';
import { ParseHelper } from 'src/app/modules/shared/parse.helper';


@Component({
  selector: 'app-task-table',
  templateUrl: './task-table.component.html',
  styleUrls: ['./task-table.component.scss']
})
export class TaskTableComponent implements OnInit, OnChanges, OnDestroy {

  @Input() filterValue: string;
  @Input() filterInColumns:any;
  @Input() selectedGroupByValue:any;
  @Input() isHideSide: boolean = false;
  @Output() onSelectTask: EventEmitter<any> = new EventEmitter();
  @Input() cols: any[] = [];
  contextMenuItems: ContextMenuItem[] = [];
  pageNumber = 1;
  pageSize = 15;
  @Input() searchValue :string;
  searchColumns = "createdDate";
  selectedTask;
  first = 0;
  tableShowMore: number[] = [15, 30, 50, 100];
  categoryModuleId : number = 0;
  categorychannelId :  number = 0;
  taskList:any[]=[];
  selecteddropdowns:any[] = [{id : 1 , name : "All"}];
  allTaskOwnerValue:any[]=[];
  allTaskCategoryValue:any;
  priorityValue:any[]=[];
  moduleValue:any[]=[];
  alTaskStatusValue:any[]=[];
  isDescending :boolean = true;
  noLeadFindOrLoadingText = "Loading...";
  totalRecords: any = 0;
  option = {id:1, label: 'All', value: 'all'};
  changeTab :any;
  showFloatHeader: boolean = false;
  forceReflow: boolean = false;
  TaskType = TaskType;
  displayAddEditDialog: boolean = false;
  isCopyTask: boolean = false;
  listingLoading: boolean = true;
  private ngUnsubscribe = new Subject<void>();
  private subscription: Subscription;
  taskChangeModule: Subscription;
  groupAllExpanded: boolean = false;

  constructor(
    private taskCategoryService: TaskCategoryService,
    public app: AppMainComponent,
    private appMainService: AppMainService,
    private tasksService: TasksService,
    private messageService: MessageService,
    private timeZoneService: TimeZoneService

  ) {
  }

  ngOnInit(): void {
    this.taskChangeModule = this.tasksService.taskCreateUpdate.subscribe(data => {
      this.selectedTask = null;
      this.option = {id:1, label: 'All', value: 'all'};
      this.getFillteredTasks();
    });
      this.refreshTask();
  }

  ngOnChanges(changes: SimpleChanges) {
      if(changes['cols'] && changes['cols'].currentValue){
        this.cols = changes['cols'].currentValue;
      }
    
      if(changes.selectedGroupByValue && (changes.selectedGroupByValue.currentValue || changes.selectedGroupByValue.currentValue === null)){
        this.selectedGroupByValue = changes.selectedGroupByValue.currentValue;
        !this.listingLoading && this.getFillteredTasks(this.pageSize, this.pageNumber);
        
      }

      if(changes.searchValue && (changes.searchValue.currentValue || changes.searchValue.currentValue === '')){
        this.searchValue = changes.searchValue.currentValue;
        this.getFillteredTasks(this.pageSize, this.pageNumber);
        
      }

      if(changes['isHideSide']){
        this.forceReflow = !this.forceReflow;
      }
      if (changes['filterInColumns'] && (changes['filterInColumns'].currentValue || changes['filterInColumns'].currentValue === null) ) {
        this.getFillteredTasks(this.pageSize, this.pageNumber);
      }
  }

  async getAllTasksWithPagination(event: LazyLoadEvent) {
    this.pageSize = event.rows;
    this.pageNumber = (event.first / event.rows) + 1;
    if (event.sortField) {
      this.searchColumns = event.sortField;
      this.isDescending = event.sortOrder == 1
    }
    !this.listingLoading && this.getFillteredTasks(this.pageSize, this.pageNumber);
  }


  //#region ListingAPICall
  getFillteredTasks(currentPageSize: number = 15, currentPageNumber: number = 1) {
    const filterValue = this.filterValue;
    this.pageSize = currentPageSize;
    const options: any = {};
    if (this.searchValue?.trim() !== '') {
      this.searchColumns = "createdDate";
    }

    const selectableColumns: any[] = [];

    if (this.cols?.length > 0) {
      this.cols.forEach((obj) => {
        if (obj.enabled) {
          selectableColumns.push(
            {
              columnName: obj.columnName,
              isCustom: obj.isCustom
            }
          )
        }
      });
    }

    const requestModel: GetTaskListingModel = {
      taskFilter:this.option.label,
      globalSearchValue: this.searchValue,
      selectableColumns: selectableColumns,
      pageSize: this.pageSize,
      pageNumber: this.pageNumber,
      sortByColumn: this.searchColumns,
      isDescending: this.isDescending,
      filterInColumns: this.filterInColumns,
      
  }
      const groupRequest: GetTaskListingGroupByRequest = {
        ...requestModel,
        groupByColumnName: this.selectedGroupByValue?.groupByColumnName,
        pageSize: 15,
        pageNumber: 1,
        rootPageSize: currentPageSize,
        rootPageNumber: currentPageNumber,
        rootSortByColumnName: this.selectedGroupByValue?.groupByColumnName,
        isRootSortByDescending: (this.selectedGroupByValue?.fieldDataType=="DateTime") as boolean,
    }
    const checkGroupColumn = groupRequest?.selectableColumns.find(field => field.columnName == this.selectedGroupByValue?.groupByColumnName);
    if (this.selectedGroupByValue && !checkGroupColumn) {
        groupRequest?.selectableColumns.push({
            columnName: this.selectedGroupByValue?.groupByColumnName,
            isCustom: this.selectedGroupByValue?.isCustom
        })
    }

    this.appMainService.isShowSpinner('getAllTasks');
    const taskApiCall = this.selectedGroupByValue ? this.tasksService.getTaskGroupList(filterValue, groupRequest) : this.tasksService.getTaskListWithFilters(filterValue, requestModel);

    taskApiCall
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (response) => {
              if (response) {
                
                let taskData = this.selectedGroupByValue ?   this.sanitizeGroupedList(response.groupedList || [])
                : this.sanitizeTasks(response?.tasks || []);
                this.taskList = taskData || [];
                this.totalRecords = response.totalCount;
                this.listingLoading = false;
                this.showFloatHeader = true;
                this.forceReflow = !this.forceReflow;
                this.appMainService.isHideSpinner('getAllTasks');
                if (this.taskList.length == 0) {
                  this.noLeadFindOrLoadingText = "No task found...";
                }
              }
            },
            error: (error) => {
              this.listingLoading = false;
              this.taskList = [];
              this.totalRecords = 0;
              this.appMainService.isHideSpinner('getAllTasks');
              this.noLeadFindOrLoadingText = "Error fetching tasks. Please try again.";
            },
            complete: () => {

            }
      })
    
  }

  sanitizeTasks(tasks: any[]): any[] {
    return tasks.map(task => ({
      ...task,
      description: removeHTMLTags(task?.description),
    }));
  }
  
  sanitizeGroupedList(groupedList: any[]): any[] {
    return groupedList.map(group => ({
      ...group,
      tasks: this.sanitizeTasks(group.tasks),
    }));
  }
   //#endregion ListingAPICall

  refreshTask() {
    this.subscription =  this.tasksService.getTaskRefreshList().subscribe(isRefresh => {
  if(isRefresh){
        this.isDescending = true;
        this.pageNumber = 1;
        this.pageSize = 15;
        this.searchColumns = "createdDate";
        this.option = { id: 1, label: 'All', value: 'all' };
        this.first = 0;
        this.getFillteredTasks();
        this.tasksService.setTaskRefreshList(false);
      }
    })
  }

  getDropDowns() {
    forkJoin({
      allTaskOwner: this.tasksService.filteredAllTaskOwner(),
      priority: this.tasksService.filteredPriority(),
      module: this.tasksService.filteredModule(),
      allTaskStatus: this.tasksService.filteredAllTaskStatus(),
      allTaskCategory: this.taskCategoryService.getTaskActiveCategoryGet(),
    }).subscribe({
      next: (results) => {
        this.allTaskOwnerValue = results.allTaskOwner;
        this.priorityValue = results.priority;
        this.moduleValue = results.module;
        this.alTaskStatusValue = results.allTaskStatus;
        this.allTaskCategoryValue = results.allTaskCategory;

      },
      error: (error) => {
        this.appMainService.isHideSpinner('columnSetting');
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error?.error?.Message ?? 'something went wrong'
        });
      }
    });
  }

  editViewTask(e, rowSelect: boolean = false) {
    if(rowSelect){
      this.selectedTask = e?.data;
      this.onSelectTask.emit(this.selectedTask);
    }else{
      this.selectedTask = e;
    this.onSelectTask.emit(this.selectedTask);
    }
    
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.taskChangeModule.unsubscribe();
  }

  populateContextMenu() {
    this.contextMenuItems.push({
      label: 'View',
      icon: 'pi pi-list',
      command: () => {
        this.editViewTask(this.selectedTask, false);
      },
    });
    this.contextMenuItems.push({
      label: 'Copy Task',
      icon: 'pi pi-copy',
      command: () => {
        this.copyTask(this.selectedTask);
      }
    });
  }

  // to check if assignTo is contains only digit 
  isNumeric(value: string): boolean {
    return /^[0-9]+$/.test(value);
  }

  //#region CopyTask

  copyTask(selectedTask) {
    this.displayAddEditDialog = true;
    this.isCopyTask = true;
    this.selectedTask = selectedTask?.id;
  }

  loadNewList(){
    this.displayAddEditDialog = false;
    this.isCopyTask = false;
    this.pageSize = 15;
    this.pageNumber = 1;
    this.getFillteredTasks();
  }

  closeTaskEdit(){
    this.displayAddEditDialog = false;
    this.isCopyTask = false;
  }

  getCompletionRatio(completed: number, total: number): any {
    if (!total || total === 0) {
      return '0';
    }
   const percentage = (completed / total) * 100;
   return Math.min(100, Math.max(0, percentage)).toFixed(0);
  }

  //find index 

  getReassignedUserIndex(rowData: any): number {
    const index = rowData?.reassignUser?.findIndex(user => user.isLoginUser);
    return index >= 0 ? index : 0;
  }

  getAssignedUserIndex(rowData: any): number {
    const index = rowData?.assignUser?.findIndex(user => user.isLoginUser);
    return index >= 0 ? index : 0;
}

getSharedUserIndex(rowData: any): number {
  const index = rowData?.sharedUser?.findIndex(user => user.isLoginUser);
  return index >= 0 ? index : 0;
}

onAllGroupExpand(){
  this.groupAllExpanded = !this.groupAllExpanded;
  this.taskList.map(rowData=>{
      rowData['expanded'] = this.groupAllExpanded;
  })
}

onGroupExpand(rowData: any){
  rowData['expanded'] = !rowData?.expanded as boolean;
}

expandSelectedRowGroup(){
  const groupByValue = this.selectedTask[this.selectedGroupByValue.columnName];
  this.groupAllExpanded = false;
  this.taskList.map((rowData: any)=>{
      rowData['expanded'] = (rowData.groupByValue==groupByValue) as boolean;
  })
}

onListPageChange($event,rowData: any){
  const filterValue = this.filterValue;
  if (this.searchValue?.trim() !== '') {
    this.searchColumns = "createdDate";
  }

  const selectableColumns: any[] = [];

    if (this.cols?.length > 0) {
      this.cols.forEach((obj) => {
        if (obj.enabled) {
          selectableColumns.push(
            {
              columnName: obj.columnName,
              isCustom: obj.isCustom
            }
          )
        }
      });
    }
  const requestModel: GetTaskListingModel = {
    taskFilter:this.option.label,
    globalSearchValue: this.searchValue,
    selectableColumns: selectableColumns,
    pageSize: 15,
    pageNumber: ($event?.page+1),
    sortByColumn: this.searchColumns,
    isDescending: this.isDescending,
    filterInColumns: ParseHelper.DeepCopy(this.filterInColumns||[]),
    
}
  let groupValue = rowData.groupById===null ? [""] : [rowData.groupById];
  let operator = "IsEqualTo";
  if(!rowData.groupByValue){
      operator = "NoValue";
  }else if(this.selectedGroupByValue?.fieldDataType=="DateTime"){
      operator = "Between";
      groupValue = [];
      let dateRangeFrom = new Date(rowData.groupByValue);
      let dateRangeTo = new Date(rowData.groupByValue);

      dateRangeFrom = this.timeZoneService._getUTCDateTimeWithZone(dateRangeFrom, (this.selectedGroupByValue?.isDateWithTime||false), true, false);
      dateRangeTo = this.timeZoneService._getUTCDateTimeWithZone(dateRangeTo, (this.selectedGroupByValue?.isDateWithTime||false), true, false);
      dateRangeTo.setDate(dateRangeTo.getDate() + 1);
      dateRangeTo = new Date(dateRangeTo.getTime() - 1000);
      groupValue.push(this.timeZoneService._getUTCDateTimeString(dateRangeFrom),this.timeZoneService._getUTCDateTimeString(dateRangeTo));
  }
  const groupFilterData: FilterInColumn = {
      name: this.selectedGroupByValue?.columnName,
      value: null,
      operator: operator,
      operationType: "AND",
      values: groupValue
  }

  const groupFilterIndex = requestModel.filterInColumns?.findIndex(filter=> filter.name==this.selectedGroupByValue?.columnName);

  if(groupFilterIndex>=0){
      requestModel.filterInColumns[groupFilterIndex] = groupFilterData;
  }else{
      requestModel.filterInColumns.push(groupFilterData);
  }

  this.appMainService.isShowSpinner('getLeadByParentId');
  this.tasksService.getTaskListWithFilters(filterValue,requestModel)
  .pipe(takeUntil(this.ngUnsubscribe))
  .subscribe({
      next: (response) => {
          if (response) {
              rowData.tasks = this.sanitizeTasks(response?.tasks || []);;
          }
          this.appMainService.isHideSpinner('getLeadByParentId');
      },
      error: (error) => {
          this.appMainService.isHideSpinner('getLeadByParentId');
          this.messageService.add({
              severity: 'error',
              summary: 'Error!',
              detail: 'Error occurring when loading leads. Please try after sometime.'
          });
      },
      complete: () => {

      }
  });
}
}
